/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {simDropdownAnimations as ɵa} from './dropdown-animations';